<template>
    <div class="redirect-form">
        <h1>re</h1>
        <form ngNoForm id="payment_confirmation" action="https://testsecureacceptance.cybersource.com/pay" method="post">
            <div v-for="(value, name) in formInputs" :key="name">
                <input type="hidden" :id="name" :name="name" :value="value" />
            </div>
        </form>
    </div>
</template>
<script>
export default {
    name: 'Redirect',
    props: {
        formInputs: {
            type: Object,
            default: () => {}
        }
    }
}
</script>